import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import { RequireAuth } from "@/components/RequireAuth";
import Landing from "@/pages/Landing";
import Marketplace from "@/pages/Marketplace";
import ProjectDetail from "@/pages/ProjectDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import AiAssistant from "@/pages/AiAssistant";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Enterprise from "@/pages/Enterprise";
import Certificate from "@/pages/Certificate";
import Cart from "@/pages/Cart";
import AcceptInvite from "@/pages/AcceptInvite";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CurrencyProvider>
          <AuthProvider>
            <CartProvider>
              <Navbar />
              <Toaster position="top-right" richColors />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/marketplace" element={<Marketplace />} />
                <Route path="/project/:id" element={<ProjectDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/enterprise" element={<Enterprise />} />
                <Route path="/certificate/:certId" element={<Certificate />} />
                <Route path="/accept-invite/:code" element={<AcceptInvite />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/ai-assistant" element={<AiAssistant />} />
                <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
                <Route path="/admin" element={<RequireAuth adminOnly><Admin /></RequireAuth>} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </CartProvider>
          </AuthProvider>
        </CurrencyProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
